module.exports = __webpack_public_path__ + "assets/5acd0800cdbcbf098102605ac2ffa930.png";